// extracted by mini-css-extract-plugin
module.exports = {"is-mob":"favoriteHeaderLink_is-mob__DDA8i","is-desk":"favoriteHeaderLink_is-desk__pZ9mS","link":"favoriteHeaderLink_link__XNOZo"};